export const buildEndpoint = (
  baseApiPath: string,
  apiVersion: string,
  service: 'reportservice',
  path: string,
) => `${baseApiPath}${service}/${apiVersion}${path.startsWith('/') ? '' : '/'}${path}`;
export const API_ENDPOINTS = {
  REPORT_SERVICE: {
    REPORTS: {
        RecentReports: '/api/v2/Reports/search',
        GetClients: '/api/v2/Reports/clients',
        GetReportTypes: '/api/v2/Reports/report-types',
        CreateReport: '/api/v2/Reports',
        DeleteReport: '/api/v2/Reports',
        GetSections: '/api/v2/Reports/{reportId}/sections',
        GetReworkSections: '/api/v2/Reports/{reportId}/sections/rework',
        UpdateSectionContent: '/api/v2/Reports/{reportId}/sections/{sectionId}',
        EditSectionText: '/api/v2/Reports/{reportId}/sections/{sectionId}/edit-text',
        TriggerRework: '/api/v2/Reports/{reportId}/rework',
        UpdateStatus: '/api/v2/Reports/{reportId}/status',
        PublishReport: '/api/v2/Reports/{reportId}/publish',
        GetReportDetails: '/api/v2/Reports/{reportId}',
        RetryReportGeneration: '/api/v2/Reports/{reportId}/generation/retry',
    },
    RECIPE: {
        Search: '/api/v2/recipe/search',
        GetDefinition: '/api/v2/recipe',
    },
    PERMISSIONS: {
      UserPermissions: '/api/v2/permissions',
    },
    FILE_PROVISIONING: {
        Validate: '/api/v2/report-files/validate',
        Upload: '/api/v2/report-files/upload',
        SupportingDocuments: '/api/v2/report-files/reports/{reportId}/supporting-documents',
        ReportPdfStream: '/api/v2/report-files/reports/{reportId}/files/{type}',
        SupportingDocumentSequence: '/api/v2/report-files/reports/{reportId}/supporting-documents/sequence',
    },
    REVIEWER: {
        GetReviewers: '/api/v2/Reviewers',
    },
    COMMENTS: {
        AddComment: '/api/v2/Reports/{reportId}/comments',
        GetComments: '/api/v2/Reports/{reportId}/comments',
        DeleteComment: '/api/v2/Reports/{reportId}/sections/{sectionId}/comments/{commentId}',
    },
    APPROVAL:{
     SubmitForReview: '/api/v2/reports/{reportId}/sections/{sectionId}/submit-for-review',
     ApproveSection: '/api/v2/reports/{reportId}/sections/{sectionId}/approve',
     RejectSection: '/api/v2/reports/{reportId}/sections/{sectionId}/reject',
    },
    REVIEW: {
        GetReview: '/api/v2/Reports/{reportId}/review',
        GetSectionChanges: '/api/v2/Reports/{reportId}/sections/{sectionId}/changes',
        RecordDecision: '/api/v2/reports/{reportId}/changes/{changeId}/decision',
        ApplyEdits: '/api/v2/Reports/{reportId}/edits/apply',
        PreviewFiles: '/api/v2/Reports/{reportId}/preview-files',
        QuickPreview: '/api/v2/Reports/{reportId}/preview'
    }
  }
}